import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IPhysicianNew, PhysicianNew } from '@core/model';
import { noWhiteSpaceValidator } from '@mynexus/mynexus-ui-lib';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-add-physician',
    templateUrl: './add-physician.component.html',
    styleUrls: ['./add-physician.component.scss'],
    standalone: false
})
export class AddPhysicianComponent implements OnInit {
  form: FormGroup;
  isFormReset = false;
  physicianData: IPhysicianNew;

  @Input() isExternalUser = false;
  @Input() set resetForm(value: PhysicianNew) {
    if (value) {
      if (this.form) {
        this.form.patchValue(value);
      }
    }
  }
  @Input() set physician(value: IPhysicianNew) {
    this.physicianData = value;

    if (this.form && value) {
      this.form.patchValue(value);
    }
  };

  get physician(): IPhysicianNew {
    return this.physicianData;
  }

  @Output() physicianChange = new EventEmitter<any>();

  ngOnInit() {
    this.createForm();
    this.setFormListener();
  }

  createForm() {
    const validators = this.isExternalUser ? [Validators.required, noWhiteSpaceValidator] : [noWhiteSpaceValidator];

    this.form = new FormGroup({
      firstName: new FormControl(null, validators),
      lastName: new FormControl(null, validators),
      practiceNpinumber: new FormControl(null, validators),
      physicalStreet: new FormControl(null, validators),
      physicalCity: new FormControl(null, validators),
      physicalState: new FormControl(null, validators),
      physicalZip: new FormControl(null, validators),
      phone: new FormControl(null, [Validators.minLength(10), Validators.maxLength(10)]),
      fax: new FormControl(null, noWhiteSpaceValidator),
    });

    if (this.physician) {
      this.form.patchValue(this.physician);
    }
  }

  setFormListener() {
    this.form.valueChanges.subscribe(res => {
      const isValid = this.isExternalUser ? this.form.valid : false;
      if (this.isCompletePhoneNumber(res.phone)){
        const unmaskedPhoneNumber = res.phone.replace(/\D/g, '');
        res.phone = unmaskedPhoneNumber;
      }
      this.physicianChange.emit({physician: res, isValid });
    });
  }

  isCompletePhoneNumber(number: string): boolean {
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return phoneRegex.test(number);
  }
}
